<ui-modal-full
  title="Alter reservation"
  (backClicked)="back()"
  (closeClicked)="close()"
  [progress]="progressPercentage()"
  [primaryAction]="primaryAction()"
  [secondaryAction]="secondaryAction()">
  @switch (mode()) {
    @case (Mode.Details) {
      <sbnb-direct-alteration-request-reservation-details
        [(alterationRequest)]="alterationRequest"
        [(alterationDetails)]="alterationDetails"
        [fetchingQuote]="fetchingQuote()"
        [reservation]="data.reservation"
        [quoteError]="quoteError()"
        (fetchQuote)="fetchQuote()"></sbnb-direct-alteration-request-reservation-details>
    }

    @case (Mode.Expiration) {
      <h2 class="m-0">How long would you like to hold the alteration request?</h2>

      <span class="block mt-4 mb-8 leading-relaxed"
        >If the alteration request expires before payment is received, Hospitable will unblock the dates.</span
      >

      <mat-radio-group class="grid gap-3" [value]="alterationRequest()?.expires_in">
        <div class="grid border rounded-lg cursor-pointer" (click)="expirationRadioButtonClicked($event, '24 hours')">
          <mat-radio-button class="!p-5" [value]="'24 hours'">
            <strong class="pl-2">24 hours</strong>
          </mat-radio-button>
        </div>
        <div class="grid border rounded-lg cursor-pointer" (click)="expirationRadioButtonClicked($event, '48 hours')">
          <mat-radio-button class="!p-5" [value]="'48 hours'">
            <strong class="pl-2">48 hours</strong>
          </mat-radio-button>
        </div>
        <div class="grid border rounded-lg cursor-pointer" (click)="expirationRadioButtonClicked($event, '72 hours')">
          <mat-radio-button class="!p-5" [value]="'72 hours'">
            <strong class="pl-2">72 hours</strong>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    }

    @case (Mode.Confirmation) {
      <h2 class="mb-8">Review and confirm</h2>
      <sbnb-direct-alteration-review-and-confirm-list
        [alterationDetails]="alterationDetails()"
        [alterationRequest]="alterationRequest()"
        [guestName]="data.reservation.guest" />
    }

    @case (Mode.Success) {
      <h2 class="m-0">Success</h2>

      <span class="block mt-4 mb-8 leading-relaxed"> The alteration request has been submitted successfully. </span>
    }
  }
</ui-modal-full>
